import { render, staticRenderFns } from "./CheckValuationTable.vue?vue&type=template&id=0ff1e12e"
import script from "./CheckValuationTable.vue?vue&type=script&lang=js"
export * from "./CheckValuationTable.vue?vue&type=script&lang=js"
import style0 from "./CheckValuationTable.vue?vue&type=style&index=0&id=0ff1e12e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports